import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

const width = ref(0)
export default function () {
    const isSmallMobile = computed(() => width.value < 350)
    const isMedSizeMobile = computed(() => width.value < 400)
    const isMobile = computed(() => width.value < 600)
    const isSmallTablet = computed(() => width.value < 800)
    const isTablet = computed(() => width.value < 1000)
    const isSmallLaptop = computed(() => width.value < 1025)
    const isMedLaptop = computed(() => width.value < 1365)
    const isLaptop = computed(() => width.value < 1440)

    function _checkScreen() {
        width.value = screen.width
    }

    onMounted(() => {
        window.addEventListener('resize', _checkScreen)
        _checkScreen()
    })

    onBeforeUnmount(() => {
        window.removeEventListener('resize', _checkScreen)
    })

    return {
        width,
        isSmallMobile,
        isMedSizeMobile,
        isMobile,
        isSmallTablet,
        isTablet,
        isSmallLaptop,
        isMedLaptop,
        isLaptop
    }
}
